export enum SessionStatusCategories {
    COMPLETED = 'completed',
    IN_PROGRESS = 'in progress',
    PENDING = 'pending',
}
